"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "2",
  cy: "2",
  r: "2"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "8",
  cy: "2",
  r: "2"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "14",
  cy: "2",
  r: "2"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "2",
  cy: "8",
  r: "2"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "8",
  cy: "8",
  r: "2"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "14",
  cy: "8",
  r: "2"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "2",
  cy: "14",
  r: "2"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "8",
  cy: "14",
  r: "2"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "14",
  cy: "14",
  r: "2"
}));

exports["default"] = _default;